import { FC } from "react";
import { useSelector } from "react-redux";
import { Redirect, useParams } from "react-router";

import { SettingsRoutes } from "routes/settings/constants";
import { selectContactForms } from "store/entities/contact-forms/selectors";
import { selectLicense } from "store/entities/license";

import { AddContactForm } from "./AddContactForm";

export const DuplicateContactForm: FC = () => {
  const { id } = useParams<{ id: string }>();
  const contactForms = useSelector(selectContactForms);
  const license = useSelector(selectLicense);

  if (!contactForms[id] && id !== "default") {
    return <Redirect to={SettingsRoutes.ContactForms} />;
  }

  const { name, ...formToDuplicateParams } =
    id === "default"
      ? { id: "default", name: "default form for widget", ...license.contactFormDefaults }
      : contactForms[id];

  const formToDuplicate = {
    name: `Copy of ${name}`,
    ...formToDuplicateParams,
  };

  return <AddContactForm settingsOverride={{ ...formToDuplicate, livechatGroupIDs: [] }} />;
};
